import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/document-color-icon.svg'


const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "entity-type-box" }
const _hoisted_3 = { class: "entity-type-text" }
const _hoisted_4 = {
  key: 0,
  class: "entity-btns-box"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "large-icon",
  src: _imports_0
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "profile-section light-bg profile-section-collapse display activeEntity"
}
const _hoisted_8 = { class: "profile-details profile-properties" }
const _hoisted_9 = { class: "pro-details-box" }
const _hoisted_10 = { class: "card-dropdown-label" }
const _hoisted_11 = ["title"]
const _hoisted_12 = {
  key: 0,
  class: "low-tone"
}
const _hoisted_13 = { class: "pro-details-box" }
const _hoisted_14 = { class: "card-dropdown-label" }
const _hoisted_15 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "entity-url-btn profile-section-collapse",
      tabindex: "0",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleAddToGraph(_ctx.data))),
      onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.handleAddToGraph(_ctx.data)), ["enter"]))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["entity-texts-box", { 
            'entity-texts-box-short': _ctx.data.hasOwnProperty('incoming'),
            'entity-texts-box-long': !_ctx.data.hasOwnProperty('incoming'),
        }])
      }, [
        _createElementVNode("h4", {
          class: "entity-label",
          title: _ctx.data.resourceLabel ?? _ctx.data.objectLabel ?? _ctx.data.object
        }, _toDisplayString(_ctx.data.resourceLabel ?? _ctx.data.objectLabel ?? _ctx.data.object), 9, _hoisted_1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.data.typeLabel ?? _ctx.data.type ?? "Literal"), 1)
        ])
      ], 2),
      (_ctx.data.hasOwnProperty('incoming'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("button", {
              tabindex: "0",
              class: "icon-btn white-bg",
              onClick: _cache[0] || (_cache[0] = (event) => { _ctx.expandConnectionsDropdown(event, _ctx.index) }),
              onKeydown: _cache[1] || (_cache[1] = _withKeys((event) => { _ctx.expandConnectionsDropdown(event, _ctx.index) }, ["enter"])),
              "aria-label": "Expand Connections Dropdown"
            }, _hoisted_6, 32)
          ]))
        : _createCommentVNode("", true)
    ], 32),
    (_ctx.currentExpandedIndex === _ctx.index)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.incoming, (incomingPred, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "low-tone",
                key: index
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("EntityResourceCard.connection")), 1),
                  _createElementVNode("p", {
                    title: 
                            incomingPred.resourceLabel ?? incomingPred.resource
                        
                  }, _toDisplayString(incomingPred.resourceLabel ?? incomingPred.resource), 9, _hoisted_11)
                ])
              ]))
            }), 128)),
            (_ctx.data?.predicate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("EntityResourceCard.predicate")), 1),
                    _createElementVNode("p", {
                      class: "truncate-text",
                      title: _ctx.data.predicateLabel ?? _ctx.data.predicate
                    }, _toDisplayString(_ctx.data.predicateLabel ?? _ctx.data.predicate), 9, _hoisted_15)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}